function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { DottySpan, SubmitButton } from "./styles";
export const SignUpButton = ({
  children,
  isLoading,
  onClick,
  size = "medium",
  ...props
}) => {
  const handleClick = event => {
    if (isLoading) return;
    onClick(event);
  };
  return /*#__PURE__*/React.createElement(SubmitButton, _extends({}, props, {
    $buttonSize: size,
    onClick: handleClick,
    "data-qa": "sign-up-button"
  }), isLoading ? /*#__PURE__*/React.createElement(DottySpan, null, "SENDING") : /*#__PURE__*/React.createElement("span", null, children));
};
SignUpButton.displayName = "SignUpButton";